<unesp-breadcrumb [routes]="breadcrumbs"></unesp-breadcrumb>
<app-identificacao-usuario></app-identificacao-usuario>
<div class="info">
  <p><b>Em desenvolvimento.</b></p>
  <hr />
  <p>Este recurso ainda não está disponível na nova plataforma.</p>
  <p>
    Continue usando o sistema
    <a href="https://sistemas.unesp.br/posgraduacao/common.perfil.action" target="_blank">SISPG</a>
  </p>
</div>
